import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // Set initial time to 23h 47m 31s
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 47,
    seconds: 31
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 md:gap-4 text-white font-montserrat font-bold text-3xl md:text-5xl" data-id="element-90">
      <div className="flex flex-col items-center bg-brand-green border border-gold/30 rounded-lg p-3 md:p-4 min-w-[70px] md:min-w-[90px] shadow-gold-glow" data-id="element-91">
        <span className="text-gold-gradient" data-id="element-92">{formatTime(timeLeft.hours)}</span>
        <span className="text-[10px] md:text-xs text-cream/70 font-inter font-normal uppercase tracking-widest mt-1" data-id="element-93">
          hs
        </span>
      </div>
      <span className="text-gold pb-6" data-id="element-94">:</span>
      <div className="flex flex-col items-center bg-brand-green border border-gold/30 rounded-lg p-3 md:p-4 min-w-[70px] md:min-w-[90px] shadow-gold-glow" data-id="element-95">
        <span className="text-gold-gradient" data-id="element-96">
          {formatTime(timeLeft.minutes)}
        </span>
        <span className="text-[10px] md:text-xs text-cream/70 font-inter font-normal uppercase tracking-widest mt-1" data-id="element-97">
          min
        </span>
      </div>
      <span className="text-gold pb-6" data-id="element-98">:</span>
      <div className="flex flex-col items-center bg-brand-green border border-gold/30 rounded-lg p-3 md:p-4 min-w-[70px] md:min-w-[90px] shadow-gold-glow" data-id="element-99">
        <span className="text-gold-gradient" data-id="element-100">
          {formatTime(timeLeft.seconds)}
        </span>
        <span className="text-[10px] md:text-xs text-cream/70 font-inter font-normal uppercase tracking-widest mt-1" data-id="element-101">
          seg
        </span>
      </div>
    </div>;
}